import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import classes from './classes.module.scss';
import PriceText from '../price_text';
import { isPrerenderMode } from '../../../../config/util';
import { AdvisorModesThemes } from '../../../../config/const';
import { isKA, isPS } from '../../../../../common/config/utils';
import { SvgIcon } from '../../../../../common/sprites';

const modeStateToIconId = {
  online: 'online',
  busy: 'online',
  offline: 'offline'
};

function AdvisorModes({
  localLiveModeMinPrice = null,
  liveModes = [],
  theme = AdvisorModesThemes.preview,
  localLiveModeMinPromoPrices = {},
  text,
  loading = false,
  showPrice = true,
  psiquicosFreeMinutesBadge = null,
  modesOnly = false
}) {
  const [showAdvisorModes, setShowAdvisorModes] = useState(false);

  useEffect(() => {
    setTimeout(() => setShowAdvisorModes(true), 100); // Need for fix hydration error
  }, []);

  const renderMode = (liveMode) => {
    const { modeState, mode } = liveMode;
    if (modeState === 'disabled') return null;

    const classContainer = theme === AdvisorModesThemes.recommendedAdvisor && isPS() ? classes[theme] : classes.modeIconContainer;
    return (
      <div className={ `${ classContainer } ${ isPS() ? classes.withBg : '' }` } key={ mode } suppressHydrationWarning>
        <SvgIcon id={ `mode_${ mode }_${ modeStateToIconId[modeState] || 'offline' }` } className={ `${ classes.modeIcon } ${ isKA() ? classes.big : '' }` } />
      </div>
    );
  };

  const renderModes = () => {
    if (isPrerenderMode() || loading || liveModes.length === 0 || !showAdvisorModes) return <div className={ classes.modesHolderSkeleton } />;
    return liveModes.map((mode) => renderMode(mode));
  };

  const isStaffPickPs = theme === AdvisorModesThemes.staffPick && isPS();

  return (
    <div className={ `${ classes[theme] || classes[AdvisorModesThemes.preview] } ${ isKA() ? classes.v2 : '' } ${ isStaffPickPs ? classes.staffPickPs : '' } ${ modesOnly ? classes.modesOnly : '' }` }>
      <div className={ `${ classes.mainContainer } ${ isKA() ? classes.reverse : '' } ${ isPS() ? classes.psiquicosMainContainer : '' }` }>
        <div className={ classes.modesHolder } suppressHydrationWarning>
          { renderModes() }
        </div>
        { isPS() && (showPrice || psiquicosFreeMinutesBadge) ? (
          <div className={ classes.centerContainer }>
            { showPrice && (
            <div className={ classes.psiquicosPriceRowContainer }>
              <div className={ classes.psiquicosPriceRow }>
                {loading ? <Skeleton height={ 48 } /> : (
                  <PriceText
                    localLiveModeMinPrice={ localLiveModeMinPrice }
                    localLiveModeMinPromoPrices={ localLiveModeMinPromoPrices }
                    text={ text }
                    liveModes={ liveModes }
                    stacked
                  />
                )}
              </div>
              { psiquicosFreeMinutesBadge ? (
                <div className={ classes.psiquicosFreeMinWrap }>
                  { psiquicosFreeMinutesBadge }
                </div>
              ) : null }
            </div>
            )}
          </div>
        ) : (!isPS() && showPrice && <PriceText localLiveModeMinPrice={ localLiveModeMinPrice } localLiveModeMinPromoPrices={ localLiveModeMinPromoPrices } text={ text } liveModes={ liveModes } />) }
      </div>
    </div>
  );
}

export default AdvisorModes;
